export default "__VITE_ASSET__CJ3J7FXU__"